/**
 * RA Variant Hooks
 * Custom RA logic that runs after CC's variant picker updates content.
 *
 * Hooks into the 'on:variant:change' event dispatched by variant-picker.js
 * after the async fetch + DOM swap completes.
 *
 * Features:
 *  1. updateInStockMessages() — toggle in-stock / vw / sold-out messages
 *  2. updateOptionsText()     — show selected options as comma-separated text
 */

(function () {
  'use strict';

  /**
   * Toggle in-stock messaging based on variant-status-map JSON.
   * The map is rendered by in-stock-messages.liquid inside the product section.
   */
  function updateInStockMessages(section, variant) {
    const immediate = section.querySelector('.in-stock-message--immediate');
    const vwMsg = section.querySelector('.in-stock-message--vw');
    const soldOutMsg = section.querySelector('.in-stock-message--soldout');
    const mapEl = section.querySelector('.variant-status-map');

    if (!immediate || !vwMsg || !soldOutMsg || !mapEl) return;

    // Hide all by default
    immediate.hidden = true;
    vwMsg.hidden = true;
    soldOutMsg.hidden = true;

    if (!variant) return;

    var statusMap = {};
    try {
      statusMap = JSON.parse(mapEl.textContent || '{}');
    } catch (e) {
      return;
    }

    // Normalize variant id (handles negative ids from combined listings)
    var vid = String(Math.abs(Number(variant.id)));
    var status = statusMap[vid];
    if (!status) return;

    var qty = Number(status.qty || 0);

    // IN STOCK
    if (qty > 0) {
      if (status.vw === true) {
        vwMsg.hidden = false;
      } else {
        immediate.hidden = false;
      }
      return;
    }

    // SOLD OUT (qty <= 0) — show only when NOT purchasable
    if (status.available === false) {
      soldOutMsg.hidden = false;
    }
  }

  /**
   * Update the selected-options summary text.
   */
  function updateOptionsText(section, variant) {
    var optionsText = section.querySelector('.product-variant-options');
    if (!optionsText) return;

    if (variant) {
      optionsText.textContent = variant.options.join(', ');
    }
  }

  /**
   * Listen for CC's variant change event on all product sections.
   */
  document.addEventListener('on:variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    var section = evt.target.closest('.shopify-section')
                  || evt.target.closest('.js-quickbuy')
                  || evt.target.closest('.cc-featured-product');

    if (!section) return;

    updateInStockMessages(section, variant);
    updateOptionsText(section, variant);
  });

  /**
   * Initial run on page load — set messages for the pre-selected variant.
   * Waits for variant-picker to initialize and fire its first content update.
   */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('variant-picker').forEach(function (picker) {
      var section = picker.closest('.shopify-section')
                    || picker.closest('.js-quickbuy')
                    || picker.closest('.cc-featured-product');
      if (!section) return;

      // Read the initial variant from the picker's JSON data
      var dataEl = picker.querySelector('[type="application/json"]');
      var variant = dataEl ? JSON.parse(dataEl.textContent) : null;

      updateInStockMessages(section, variant);
      updateOptionsText(section, variant);
    });
  });
})();
